export default __webpack_public_path__ + "static/media/Textilslöjd2.8dee8885.jpeg";